import { CITY_FIELD, COUNTY_FIELD, STATE_FIELD, ZIP_FIELD } from "../config/stepper-form";
import { COUNTRY_WITH_COUNTY } from "../constants";
import states from "../constants/states";
import { markCountyFieldAsOptionsal, markCountyFieldAsRequired, updateOptions } from "../form-store/action-types";

export const isCountryWithStateOptions = country => country && COUNTRY_WITH_COUNTY.some(ctry => ctry === country);

export const checkIfNotNull = val => val !== "" && val !== undefined && val !== null;

export const checkIfEqual = val => checkIfNotNull(val) && val !== undefined && val !== null;

export const toggleCountyRequiredField = ctry => dispatch => {
  if (isCountryWithStateOptions(ctry)) {
    dispatch(markCountyFieldAsRequired());
  } else {
    dispatch(markCountyFieldAsOptionsal());
  }
};

const getOptions = (aryOpts = [], field) => {
  let _filteredOpts = [];
  for (let itm of aryOpts) {
    if (_filteredOpts.indexOf(itm[field]) === -1) {
      _filteredOpts.push(itm[field]);
    }
  }
  return _filteredOpts.map(fld => ({ label: fld, value: fld }));
};


const checkIfCityMatch = (option, customer) => customer[CITY_FIELD.name].value? customer[CITY_FIELD.name].value === option[CITY_FIELD.name] : false;

const filterZipCodeOptions = (customer, aryOpts = [], field, filter, filterField) => {
  let _filteredOpts = [];
  for (let itm of aryOpts) {
    if (filter && _filteredOpts.indexOf(itm[field]) === -1 && itm[filterField] === filter) {
      _filteredOpts.push(itm[field]);
    }
  }
  return _filteredOpts.map(fld => ({ label: fld, value: fld }));
};

const filterCountyOptions = (customer, aryOpts = [], field, filter, filterField) => {
  let _filteredOpts = [];
  for (let itm of aryOpts) {
    if (filter && checkIfCityMatch(itm, customer) && _filteredOpts.indexOf(itm[field]) === -1 && itm[filterField] === filter) {
      _filteredOpts.push(itm[field]);
    }
  }
  return _filteredOpts.map(fld => ({ label: fld, value: fld }));
};

export const resetStateAndDependentField = () => dispatch => {
  dispatch(resetCities());
  dispatch(resetZipCodes());
  dispatch(resetCountyOptions());
};

// State field
export const updateStates = value => (dispatch, getState) => {
    const _ctryCode = getState().form.customer.countryCode?.value;
    dispatch(updateOptions({ name: STATE_FIELD.name, options: states[value] ? states[value] : [] }));  
    if(_ctryCode !== "US") {
      dispatch(resetStateAndDependentField());
    }
};

export const resetStates = () => (dispatch) => {
  dispatch(updateOptions({ name: STATE_FIELD.name, options: [] }));
};

// City field
export const updateCities = () => (dispatch, getState) => {
  const { app } = getState();
  dispatch(updateOptions({ name: CITY_FIELD.name, options: getOptions(app.options, CITY_FIELD.name) }));
};

export const resetCities = () => (dispatch) => {
  dispatch(updateOptions({ name: CITY_FIELD.name, options: []}));
};

// Zipcode field
export const updateZipCodes = () => (dispatch, getState) => {
  const _state = getState();
  const { app, form } = _state;
  const _customerObj = form.customer;
  let _val = (_customerObj[CITY_FIELD.name] && _customerObj[CITY_FIELD.name].value) ? _customerObj[CITY_FIELD.name].value : _customerObj[CITY_FIELD.name];
  dispatch(updateOptions({ name: ZIP_FIELD.name, options: filterZipCodeOptions(_customerObj, app.options, ZIP_FIELD.apifieldname, _val, CITY_FIELD.name) }));
};

export const resetZipCodes = () => (dispatch) => {
  dispatch(updateOptions({ name: ZIP_FIELD.name, options: [] }));
};

// County field
export const updateCounty = () => (dispatch, getState) => {
  const { app, form } = getState();
  const _customerObj = form.customer;
  let _val = (_customerObj[ZIP_FIELD.name] && _customerObj[ZIP_FIELD.name].value) ? _customerObj[ZIP_FIELD.name].value : _customerObj[ZIP_FIELD.name];
  dispatch(updateOptions({ name: COUNTY_FIELD.name, options: filterCountyOptions(_customerObj, app.options, COUNTY_FIELD.name, _val, ZIP_FIELD.apifieldname) }));
};

export const resetCountyOptions = () => (dispatch) => {
  dispatch(updateOptions({ name: COUNTY_FIELD.name, options: [] }));
};
